import React from 'react'
import { Link } from 'gatsby'

import { withNamespaces } from 'react-i18next'

import logo from '../assets/images/logo_avalingua.png'

const Header = props => {
  const { t } = props

  return (
    <header id="header" className="alt">
      <div className="language-switcher">
        <ul>
          <li>
            <Link to="/">en</Link>
          </li>
          <li>
            <Link to="/gl">gl</Link>
          </li>
          <li>
            <Link to="/es">es</Link>
          </li>
          <li>
            <Link to="/pt">pt</Link>
          </li>
        </ul>
      </div>
      <span className="logo">
        <img src={logo} alt="" />
      </span>
      <h1>Avalingua.</h1>
      <p>{t('Grammar checker for Spanish, Galician, and Portuguese.')}</p>
    </header>
  )
}

export default withNamespaces()(Header)
